import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { FieldValues, RegisterOptions, useController } from 'react-hook-form';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface TextareaFieldProps extends HookFormProps {
  autoHeight?: boolean;
  width?: number;
  height?: number;
  placeholder?: string;
  maxLength?: number;
  viewLength?: boolean;
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, 'setValueAs' | 'disabled' | 'valueAsNumber' | 'valueAsDate'>
    | undefined;
}

const TextareaField = ({
  prefixName,
  autoHeight,
  width,
  height,
  placeholder,
  maxLength = 300,
  viewLength = true,
  rules,
}: TextareaFieldProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const { field, fieldState } = useController({ name: `${prefixName}`, rules });
  const length = field.value?.length ?? 0;
  const [textAreaHeight, setTextAreaHeight] = useState(`${height}px`);

  const handleResizeHeight = () => {
    if (!autoHeight || !ref.current) return;

    const target = ref.current;
    target.style.height = '0';
    target.style.height = `${target.scrollHeight}px`;
    setTextAreaHeight(`${target.scrollHeight}px`);
  };

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) {
      return;
    }

    field.onChange(e.target.value);
  };

  useEffect(() => {
    handleResizeHeight();
  }, [field.value]);

  return (
    <div className={cx('textareaWrap')}>
      <div className={cx({ error: fieldState.invalid })} style={{ width, height: textAreaHeight, minHeight: height }}>
        <textarea
          {...field}
          ref={ref}
          placeholder={placeholder}
          maxLength={maxLength}
          onChange={onChange}
          style={{ minHeight: height }}
        />
      </div>
      {viewLength && !!length && (
        <div className={cx('infoText')}>
          최대 글자수 : <span className={cx('value')}>{length}</span> / {maxLength}
        </div>
      )}
      {!length && fieldState.invalid && <div className={cx('errorMessage')}>{fieldState.error?.message}</div>}
    </div>
  );
};

export default TextareaField;
